import React from 'react';

interface PreReleaseSetupStatusProps {
  onRetry?: () => void;
}

export const PreReleaseSetupStatus: React.FC<PreReleaseSetupStatusProps> = ({ onRetry }) => {
  return (
    <div className="pre-release-setup-status">
      <div className="setup-status-card">
        <div className="setup-icon">
          <i className="bi bi-tools" style={{ fontSize: '3rem', color: '#667eea' }}></i>
        </div>

        <h2>Pre-Release Tracker Setup Required</h2>

        <p className="setup-description">
          The Pre-Release Interest & Feedback Tracker feature is ready to use, but requires
          database setup to be completed first.
        </p>

        <div className="setup-steps">
          <h3>Setup Instructions:</h3>
          <ol>
            <li>
              <strong>Run Database Migrations:</strong>
              <p>Execute the following migration files in your Supabase SQL editor:</p>
              <div className="code-block">
                <code>supabase/migrations/44_pre_release_tracker_schema.sql</code><br />
                <code>supabase/migrations/45_pre_release_tracker_rls.sql</code><br />
                <code>supabase/migrations/46_pre_release_tracker_functions.sql</code>
              </div>
            </li>
            <li>
              <strong>Verify Setup:</strong>
              <p>Once migrations are complete, refresh this page to start using the feature.</p>
            </li>
          </ol>
        </div>

        <div className="setup-features">
          <h3>What You'll Get:</h3>
          <ul>
            <li>📊 Project publishing and management</li>
            <li>💡 Community interest tracking</li>
            <li>💬 Feedback and feature request system</li>
            <li>🎛️ Publisher dashboard with analytics</li>
            <li>🔒 Trust and reliability system</li>
            <li>🎟️ Automatic discount code generation</li>
          </ul>
        </div>

        {onRetry && (
          <button
            className="retry-setup-btn"
            onClick={onRetry}
          >
            <i className="bi bi-arrow-clockwise"></i>
            Check Setup Status
          </button>
        )}

        <div className="setup-note">
          <p>
            <strong>Note:</strong> This is a one-time setup process. Once completed,
            the Pre-Release Tracker will be fully functional for all users.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PreReleaseSetupStatus;